var map = {
	"./active": "5448",
	"./active.yml": "5448",
	"./event-2026-06_001_invitation": "41a5",
	"./event-2026-06_001_invitation.yml": "41a5",
	"./event-2026-06_002_presale-announcement": "d889",
	"./event-2026-06_002_presale-announcement.yml": "d889",
	"./event-2026-06_003_presale-reminder": "1447",
	"./event-2026-06_003_presale-reminder.yml": "1447"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e577";